<template>
  <div class="flex flex-col justify-between h-full">
    <div class="text-gray-700 text-center bg-primary header-tittle flex items-center justify-between">
      <feather-icon class="cursor-pointer" @click="closed_card" icon="ArrowLeftIcon" />
      <div>{{ $t(`INPUTTYPE.${type}.${inputType}`) }}</div>
      <div class="center-text-meddle"></div>
    </div>
    <div :id="`body-sidebar${index}`" class="text-gray-700 text-center body-sidebar">
      <vs-row class="text-left" vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" :vs-lg="WichComponent === 'Action' ? 12:10">
         <component :is="WichComponent" :index="index" :key="index"></component>
        </vs-col>
      </vs-row>
    </div>
    <!--Fin Body sidebar -->
    <div class="text-gray-700 text-center footer-sidebar flex items-center">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <vs-button
            v-if="requiredOrigin"
            class="ml-3 hidden lg:inline-block w-1/2"
            color="success"
            type="border"
            @click="OpenPopup()"
            >{{ $t("FORMS.datasource") }}</vs-button
          >
          <vs-button
            v-else
            class="ml-3 hidden lg:inline-block w-1/2"
            color="success"
            type="border"
            @click="closed_card"
            >{{ $t("FORMS.exit") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" :vs-lg="width" vs-sm="12" vs-xs="12">
          <vs-button class="ml-3 hidden lg:inline-block w-1/2" color="success" type="border" @click="closed_card">{{
            $t("FORMS.save")
          }}</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapState, mapMutations } from "vuex";
import { setQuestion } from "@/serviforms/designer/indexDB/logic.js";
import { AllComponents } from "./Components-questions.js";
export default {
  props: ["index"],
  components: { ...AllComponents },
  data() {
    return {
      Default: ["default", "textarea", "multiInput", "checktext"],
      Number: ["number", "currency"],
      Color: ["QRGen", "sign", "dialog"],
      Geo: ["google", "servi"],
      Phone: ["phone"],
      Password: ["password"],
      Ranking: ["ranking"],
      Slider: ["slider"],
      Date: ["datetime", "calendar", "time"],
      Choice: ["multi"],
      RadioOther: ["radioOther"],
      RadioOther: ["radioOther"],
      MultiOther: ["multiOther"],
      Radio: ["radio"],
      Email: ["email", "domain"],
      Switch_: ["switch"],
      Label: ["label", "section"],
      Action: ["action"],
      Viewer: ["document", "web"],
      Subformulario: ["standar"],
      Link: ["link"],
      Paragraph: ["paragraph"],
      Url_: ["url"],
      Map: ["google", "servi"],
      OriginStandar: ["standar"],
      OriginBase: ["database"],
      OriginSelect: ["select"],
      Scala: ["scala"],
      ListInformative: ["info"],
      File: ["default"]
    };
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    /**
     * Cierrra la ventana de configuración de la pregunta.
     */
    closed_card() {
      setQuestion();
      this.$emit("active", false);
    },
    /**
     * Muestra el popup para el origen de datos para configurar opciones para ciertos componentes.
     */
    OpenPopup() {
      if (this.type === "choice" || this.inputType === "scala")
        this.UPDATE_STATE({ key: "componentPopup", value: "Choice" });
      if (this.inputType === "info") this.UPDATE_STATE({ key: "componentPopup", value: "InformativeList" });
      this.UPDATE_STATE({ key: "activePopup", value: true });
      this.UPDATE_STATE({ key: "indexQuestion", value: this.index });
    }
  },
  computed: {
    ...mapState("resource", ["questionsByPage"]),
    /**
     * Obtiene el tipo de pregunta
     */
    type() {
      return this.questionsByPage[this.index].type;
    },
    /**
     * Obtiene la clase de pregunta.
     */
    inputType() {
      return this.questionsByPage[this.index].inputType;
    },
    /**
     * Obtiene el componente a renderizar.
     */
    WichComponent() {
      if (this.type === "file") {
        if (this.File.includes(this.inputType)) return "File";
      }

      if (this.Default.includes(this.inputType)) return "Default";
      if (this.Number.includes(this.inputType)) return "NumberCurrency";
      if (this.Scala.includes(this.inputType)) return "Scala";
      if (this.Color.includes(this.inputType)) return "Color";

      if (this.type === "map") return "Map";
      if (this.type === "geo") if (this.Geo.includes(this.inputType)) return "Geo";

      if (this.Phone.includes(this.inputType)) return "DefaultSelect";
      if (this.Password.includes(this.inputType)) return "Password";
      if (this.Ranking.includes(this.inputType)) return "Ranking";
      if (this.Slider.includes(this.inputType)) return "Slider";
      if (this.Date.includes(this.inputType)) return "Date";
      if (this.Choice.includes(this.inputType)) return "Multiple";
      if (this.RadioOther.includes(this.inputType)) return "RadioOther";
      if (this.MultiOther.includes(this.inputType)) return "MultiOther";
      if (this.Radio.includes(this.inputType)) return "Radio";
      if (this.Email.includes(this.inputType)) return "Email";
      if (this.Switch_.includes(this.inputType)) return "Switch_";
      if (this.Label.includes(this.inputType)) return "Label";
      if (this.Viewer.includes(this.inputType)) return "Viewer";
      if (this.ListInformative.includes(this.inputType)) return "ListInformative";

      if (this.type === "datasource") {
        if (this.OriginBase.includes(this.inputType)) return "OriginBase";
        if (this.OriginSelect.includes(this.inputType)) return "OriginSelect";
        return "OriginStandar";
      }
      if (this.type === "subform") return "Subformulario";
      // if (this.Subformulario.includes(this.inputType)) return 'Subformulario';

      if (this.Link.includes(this.inputType)) return "Link";
      if (this.Action.includes(this.inputType)) return "Action";
      if (this.Paragraph.includes(this.inputType)) return "Paragraph";
      if (this.Url_.includes(this.inputType)) return "Url_";
    },
    width() {
      return "6";
      // if (this.requiredOrigin) return "8";
      // else return "12";
    },
    /**
     * valida que componentes se pueden configurar con un origen de datos.
     */
    requiredOrigin() {
      const condition1 = this.type === "choice" || this.inputType === "scala";

      if (this.inputType === "info") {
        if (this.questionsByPage[this.index].hasOwnProperty("properties")) {
          if (this.questionsByPage[this.index].properties.default === "datasource") return true;
          return false;
        }
      }
      return condition1;
    }
  },
  mounted() {
      if (!!this.WichComponent) return this.$emit("hasComponent", true);
      return this.$emit("hasComponent", false);
  },
  watch: {
    WichComponent: function (value) {
      if (!!value) return this.$emit("hasComponent", true);
      return this.$emit("hasComponent", false);
    }
  }
};
</script>
<style lang="scss" scoped>
$vs-primary: #38bdaa;
$header: 4rem;
$footer: 5rem;
$body: calc(100% - #{$header} - #{$footer});
$padding-sidebar: 15px;

.header-tittle {
  height: $header;
  font-weight: bold;
  padding: $padding-sidebar;
  color: #ffff;
}

.footer-sidebar {
  height: $footer;
  padding: $padding-sidebar;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.body-sidebar {
  height: $body;
  overflow-y: auto;
  padding: $padding-sidebar;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
}
</style>
